import {action, makeAutoObservable} from "mobx";
import CommonStore from "../../../stores/CommonStore";
import { MoneyDeliveryService } from "../../../service/productOrder/MoneyDeliveryService";
import MoneyDeliveryOrderDetailsResponse from "../../../model/productOrder/moneyDelivery/MoneyDeliveryOrderDetailsResponse";

class MoneyDeliveryPrintStore {

    public productOrderIds: string[];
    public moneyDeliveryOrders: MoneyDeliveryOrderDetailsResponse[];
    public isModalOpen: boolean;
    public loading: boolean;
    public commonStore: CommonStore;


    constructor(commonStore: CommonStore, productOrderIds: string[]) {
        this.productOrderIds = [...productOrderIds];
        this.moneyDeliveryOrders = [];
        this.isModalOpen = false;
        this.loading = false;
        this.commonStore = commonStore;
        makeAutoObservable(this);
    }

    @action
    public async loadInvoice() {
        this.loading = true;
        this.moneyDeliveryOrders = [];
        for (const productOrderId of this.productOrderIds) {
            const response = await MoneyDeliveryService.find(productOrderId!);
            this.commonStore.processErrors(response);
            if (response.success && response.data) {
                this.moneyDeliveryOrders.push(response.data);
            }
        }        
        this.loading = false;
    }

    @action
    public async openModal() {
        this.isModalOpen = true;
        await this.loadInvoice();
    }

    @action
    public closeModal() {
        this.isModalOpen = false;
    }
}

export default MoneyDeliveryPrintStore;